import { useEffect } from "react";
import { t } from "@/i18n-js/instance";
import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";
import { CustomizeHome } from "@circle-react/components/HomePageV2/Header/CustomizeHome";
import { usePunditUserContext } from "@circle-react/contexts";
import { useHomePageApi } from "@circle-react/hooks/home_page/useHomePageApi";
import { useBoolean } from "@circle-react/hooks/utils/useBoolean";
import { WelcomeBannerContent } from "./WelcomeBannerContent";

export interface WelcomeBannerV2Props {
  community_member_id: number;
}

export const WelcomeBannerV2 = ({
  community_member_id,
}: WelcomeBannerV2Props) => {
  const {
    isWelcomeBannerVisible,
    bannerData,
    fetchBannerData,
    setWelcomeBannerPreference,
    isBannerDataLoading,
  } = useHomePageApi();

  const [shouldShowCustomizeModal, toggleCustomizeModal] = useBoolean(false);
  const { is_video, media_url, title, description, allow_close, enabled } =
    bannerData;

  const { currentCommunityMember, refetch } = usePunditUserContext();

  const isAdmin = isCommunityAdmin(currentCommunityMember);

  useEffect(() => {
    void fetchBannerData();
  }, []);

  const handleClose = async () => {
    await setWelcomeBannerPreference({
      communityMemberId: community_member_id,
      display: false,
    });
    await refetch();
  };

  const hasWelcomeBanner = Boolean(enabled && isWelcomeBannerVisible);

  if (isBannerDataLoading) {
    return null;
  }

  return (
    <>
      {hasWelcomeBanner ? (
        <WelcomeBannerContent
          isLoading={isBannerDataLoading}
          isAdmin={isAdmin}
          editBannerClick={toggleCustomizeModal}
          closeClick={handleClose}
          allowClose={allow_close}
          mediaUrl={media_url}
          title={title}
          description={description}
          isVideo={is_video}
        />
      ) : null}
      <CustomizeHome
        shouldShowCustomizeModal={shouldShowCustomizeModal}
        toggleCustomizeModal={toggleCustomizeModal}
        initialSection={t("home_page.banners")}
      />
    </>
  );
};
